import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMe } from 'platform-components/src/components/user/selectors';

import { SALES_CODE_SCENARIO } from 'common.components/sales-code-modal/constants';
import { SalesCodeModal } from 'common.components/sales-code-modal/sales-code-modal';
import { getShouldShowSalesCodeModal } from 'common.components/sales-code-modal/selectors';
import * as userActions from 'common.components/user/actions';
import { getAllEventCodes } from 'common.components/user/selectors';
import { usePostTeacherReservePromocode, getTeacherReservePromocodesPrefixes } from 'store/teacher-reserve';

export const SalesCodeModalContainer = () => {
    const dispatch = useDispatch();

    const me = useSelector(getMe);
    const shouldShow = useSelector(getShouldShowSalesCodeModal);
    const allCodes = useSelector(getAllEventCodes);
    const teacherReservePromocodesPrefixes = useSelector(getTeacherReservePromocodesPrefixes);

    const [postTeacherReservePromocode] = usePostTeacherReservePromocode();

    const [existedCodes, setExistedCodes] = useState(allCodes);

    const saveSalesCode = (currentSalesCode: string | null) => {
        if (currentSalesCode) {
            // Если добавленный промокод принадлежит кадровому резерву
            if (teacherReservePromocodesPrefixes.some((prefix) => currentSalesCode.startsWith(prefix)) && me) {
                postTeacherReservePromocode({ userId: me.id, promocode: currentSalesCode });
            } else {
                dispatch(userActions.saveSalesCode(currentSalesCode));
            }
            setExistedCodes([...existedCodes, currentSalesCode]);
        }
    };

    return (
        <SalesCodeModal
            disabled={false}
            existedCodes={existedCodes}
            onSave={saveSalesCode}
            opened={shouldShow}
            savedSalesCode={null}
            scenario={SALES_CODE_SCENARIO.FROM_ACCOUNT}
        />
    );
};
